/**
 * Shared chat session helpers used by both ChatWidget and TalkToUs.
 * State is persisted in localStorage so conversations survive navigation.
 */

export interface ChatMsg {
  from: "user" | "bot";
  text: string;
}

const KEY = "kiba_chat_session";

export const GREETING: ChatMsg = {
  from: "bot",
  text: "Hi! I'm Kiba, your KIBA Labs assistant. Ask me anything about our services, products, or how to work with us, I'm here to help!",
};

interface Session {
  messages: ChatMsg[];
  count: number; // user-sent message count
}

export function loadSession(): Session {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const parsed: Session = JSON.parse(raw);
      if (Array.isArray(parsed.messages) && parsed.messages.length > 1) {
        return { messages: parsed.messages, count: parsed.count ?? 0 };
      }
    }
  } catch { /* ignore parse errors */ }
  return { messages: [GREETING], count: 0 };
}

export function saveSession(messages: ChatMsg[], count: number): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ messages, count }));
  } catch { /* quota exceeded — ignore */ }
}

export function clearSession(): void {
  try {
    localStorage.removeItem(KEY);
  } catch { /* ignore */ }
}
